import { assessmentStore } from 'ats/pages/job-positions/AssessmentStore';
import React from 'react';
import Async from 'react-select/async';
import { reactSelectAtsComponents } from 'ats/components/react-select/reactSelectAtsComponents';

export class AssessmentsDropdown extends React.Component {
	state = {
		value: null,
		loaded: false
	};
	async componentDidMount() {
		if (this.props.value) {
			this.setState({ value: this.props.value });
		}
		this.setState({ loaded: true });
	}

	render() {
		if (this.state.loaded) {
			return (
				<Async
					menuPosition={'fixed'}
					maxMenuHeight="300"
					className={
						'react-select assessments-dropdown ' +
						(this.props.styleVersion ? this.props.styleVersion : '')
					}
					classNamePrefix="react-select"
					components={reactSelectAtsComponents}
					cacheOptions
					value={this.state.value}
					placeholder={this.props.placeholder ?? 'Assessments'}
					isMulti={this.props.isMulti}
					required={this.props.required}
					defaultOptions
					loadOptions={this.loadOptions}
					getOptionValue={this.getOptionValue}
					getOptionLabel={this.getOptionLabel}
					noOptionsMessage={this.noOptionsMessage}
					onChange={item => {
						if (this.props.onValueChange) {
							this.props.onValueChange(item);
						}
						this.setState({ value: item });
					}}
				/>
			);
		} else {
			return null;
		}
	}

	loadOptions = inputValue => {
		return new Promise(resolve => {
			resolve(this.getAssessments(inputValue));
		});
	};

	getAssessments = async inputValue => {
		inputValue = inputValue.replace(/\W/g, '');
		const result = await assessmentStore.getAssessments({
			text: inputValue
		});
		return result.data;
	};

	noOptionsMessage = value => {
		if (value.inputValue && value.inputValue.length >= 1) {
			return 'No matches found';
		} else {
			return 'Enter text to search';
		}
	};

	getOptionValue = option => option.id;

	getOptionLabel = option => `${option.name}`;
}
